/**
 * Maximum quantity that a customer can add for each product
 */
const MAXIMUM_PRODUCT_QUANTITY = 9999;
const MINIMUM_PRODUCT_QUANTITY = 1;

/**
 * Returns the given ProductItem's delivery countries as an array of strings.
 * Note that the array consists of lowercase country codes.
 */
const getDeliveryCountries = (product: ProductItem): string[] => {
    const deliveryCountryString = product.deliveryCountry;

    try {
        const deliveryCountries = JSON.parse(deliveryCountryString);
        if (!Array.isArray(deliveryCountries)) return [];
        return deliveryCountries.map(countryCode => String(countryCode).toLowerCase());
    } catch {
        // If invalid JSON, return empty array
        return [];
    }
}

export {
    MAXIMUM_PRODUCT_QUANTITY,
    MINIMUM_PRODUCT_QUANTITY,
    getDeliveryCountries,
};